import TrainingVoucherContent from '@/features/product/product-modal/components/TrainingVoucherContent';
import {VALIDATION_ERROR_CODES} from '@/features/product/product-constants';

/**
 * Registry mapping product type strings to modal configuration.
 *
 * Each entry defines:
 * - ContentComponent        - React component rendered in the modal body
 * - initialState {Object}   - Default form state; reset on close
 * - validate {Function}     - Receives current state; returns {valid: boolean, fields: {[fieldName]: {errors: Object|null}}}
 * - getSubmitPayload {Function} - Receives current state; returns payload passed to onSubmit
 *
 * To support a new product type, add an entry here and create a corresponding
 * content component — no changes to ProductModal are needed.
 */
export const MODAL_REGISTRY = {
  trainingvouchers: {
    ContentComponent: TrainingVoucherContent,
    initialState: {quantity: 0, policyAccepted: false, selectedProduct: null},
    validate: (state) => {
      const fields = {
        selectedProduct: {
          errors: state.selectedProduct ? null : {[VALIDATION_ERROR_CODES.REQUIRED]: true},
        },
        quantity: {
          errors: state.quantity >= 1 ? null : {[VALIDATION_ERROR_CODES.MIN]: {min: 1, actual: state.quantity}},
        },
        policyAccepted: {
          errors: state.policyAccepted ? null : {[VALIDATION_ERROR_CODES.REQUIRED]: true},
        },
      };
      return {valid: Object.values(fields).every((f) => !f.errors), fields};
    },
    getSubmitPayload: (state) => ({quantity: state.quantity, sku: state.selectedProduct}),
  },
};
